// «IMPRIMANTA» — animația de generare: semnul logoului, plăcile-romb din
// favicon (`public/favicon.svg`), pus placă cu placă, de jos în sus. Aici e
// desenul; mișcarea e în `imprimanta.css`. Coordonatele sunt ale favicon-ului,
// pe grila lui de 32, ca animația și semnul să nu se despartă.

/** Placa semnului: rombul de sus, de la x = 5 la 27 și înalt de 5, cu cantul
 *  de 1,5 sub el. Plăcile se urmează la 6,5, deci colțul de jos al uneia
 *  atinge vârful celei de dedesubt, ca în semn. `SUS` e mijlocul rombului de
 *  pe placa de sus. */
const X0 = 5, X1 = 27, CX = 16, SEMI = 2.5, CANT = 1.5, PAS = 6.5, SUS = 9;

/** Culorile semnului pe fond deschis (setul `.deschis` al favicon-ului, ale
 *  semnului din bara site-ului), de sus în jos: oțelul se întunecă spre bază,
 *  placa de jos e cea teal. Prima și a patra sunt cele două plăci de oțel ale
 *  semnului; între ele, două trepte egale. */
const PLACI = [
  { fata: "#a9b4c0", cant: "#5f6b7a" },
  { fata: "#96a2ae", cant: "#535e6d" },
  { fata: "#848f9d", cant: "#46515f" },
  { fata: "#717d8b", cant: "#3a4452" },
  { fata: "#22c3d7", cant: "#0d7f8e" },
] as const;

/** Silueta plăcii (fața cu cantul; fața se pune peste ea) și rombul feței. */
function placa(y: number) {
  return {
    silueta: `M${X0} ${y}L${CX} ${y - SEMI}L${X1} ${y}V${y + CANT}L${CX} ${y + SEMI + CANT}L${X0} ${y + CANT}Z`,
    romb: `M${X0} ${y}L${CX} ${y - SEMI}L${X1} ${y}L${CX} ${y + SEMI}Z`,
  };
}

/** De jos în sus: ordinea în care apar și în care se desenează — placa de
 *  deasupra acoperă vârful celei de dedesubt când coboară sub locul ei. */
const DE_JOS = PLACI.map((c, i) => ({ ...c, ...placa(SUS + i * PAS) })).reverse();

/** Animația, singură. `stinsa`: nemișcată și ștearsă — rularea așteaptă la rând,
 *  nu lucrează. `inaltime` e în pixeli; lățimea urmează desenul. */
export function Imprimanta({ stinsa = false, inaltime = 320 }: { stinsa?: boolean; inaltime?: number }) {
  return (
    <svg className={stinsa ? "imprimanta stinsa" : "imprimanta"} viewBox="4 4.75 24 36"
         height={inaltime} width={Math.round(inaltime * 24 / 36)} aria-hidden="true">
      <g className="imp-semn">
        {DE_JOS.map((p, k) => (
          <g key={k} className={`imp-placa imp-p${k}`}>
            <g className="imp-plutire">
              <path d={p.silueta} fill={p.cant} />
              <path d={p.romb} fill={p.fata} />
            </g>
          </g>
        ))}
      </g>
    </svg>
  );
}

/** Scena generării: animația direct pe pagină, în locul în care va apărea
 *  planșa, cu titlul și nota rulării sub ea. */
export function ScenaGenerare({ titlu, nota, stinsa = false }: {
  titlu: string; nota?: string | null; stinsa?: boolean;
}) {
  return (
    <div className="scena-generare" role="status">
      <Imprimanta stinsa={stinsa} />
      <div>
        <span className="titlu">{titlu}</span>
        {nota && <span className="nota">{nota}</span>}
      </div>
    </div>
  );
}
